import { ComponentProps, FC, ReactElement } from "react";
import styles from "./styles.module.scss";
import { useThrottle } from "@/common/hooks/useThrottle";
import { Typography } from "@/shared/ui/Typography";
import { BRAND_COLOR } from "@/styles/colorsJS";
import { twCn } from "@/styles/utils";

interface Props extends ComponentProps<"button"> {
  id: string;
  text: ReactElement | string;
  Icon?: ReactElement;
  active?: boolean;
}

export const SecondaryButton: FC<Props> = ({
  id,
  text,
  Icon,
  onClick,
  className,
  active,
}) => {
  const throttledClick = useThrottle(onClick);
  return (
    <button
      id={`${id}-button`}
      className={twCn(styles.customButton, className)}
      onClick={throttledClick}
    >
      <div className="flex items-center gap-2">
        {!!Icon && Icon}
        <Typography
          type="bodySmall"
          weight={active ? "bold" : undefined}
          color={active ? BRAND_COLOR : "inherit"}
        >
          {text}
        </Typography>
      </div>
    </button>
  );
};
